import { useQuery } from '@tanstack/react-query';
import HomeServices from '../pages/home/homeService/HomeService';

// Home səhifəsi üçün query hooks
export const useCampaigns = (selectedLanguage?: string | null) => {
  return useQuery({
    queryKey: ['campaigns', selectedLanguage],
    queryFn: async () => {
      const res = await HomeServices.CampaignData();
      return res;
    },
    enabled: true,
    staleTime: 5 * 60 * 1000, // 5 dəqiqə
  });
};

export const useOfferWeek = (selectedLanguage?: string | null) => {
  return useQuery({
    queryKey: ['offerWeek', selectedLanguage],
    queryFn: async () => {
      const response = await HomeServices.getOfferWeek();
      return response;
    },
    enabled: true,
    staleTime: 5 * 60 * 1000,
  });
};

export const useMostSeller = (selectedLanguage?: string | null) => {
  return useQuery({
    queryKey: ['mostSeller', selectedLanguage],
    queryFn: async () => {
      const res = await HomeServices.MostSellerData();
      return res;
    },
    enabled: true,
    staleTime: 5 * 60 * 1000,
  });
};

export const useSelectedServices = (selectedLanguage?: string | null) => {
  return useQuery({
    queryKey: ['selectedServices', selectedLanguage],
    queryFn: async () => {
      const res = await HomeServices.selectedServices();
      return res;
    },
    enabled: true,
    staleTime: 5 * 60 * 1000,
  });
};

export const useOfficialServices = () => {
  return useQuery({
    queryKey: ['officialServices'],
    queryFn: async () => {
      const res = await HomeServices.getPartnors();
      return res;
    },
    enabled: true,
    staleTime: 10 * 60 * 1000, // 10 dəqiqə
  });
};

